import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PrintableContent } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { ReportCoverPage } from '../report-cover-page/report-cover-page';
import { ReportFooter } from '../report-footer';

@Component({
  selector: 'cfp-portfolio-report',
  styleUrls: ['portfolio-report.scss'],
  templateUrl: 'portfolio-report.html',
  imports: [PrintableContent, TranslateModule, DatePipe, ReportCoverPage, ReportFooter],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortfolioReport implements OnInit {
  public readonly portfolioId = input.required<number>();
  public readonly organizationName = input<string>();
  public readonly organizationId = input<string | undefined>();
  public readonly reportTitle = input<string>();
  public readonly logo = input<string>();
  public readonly portfolioBuildingsSummaryCoverImage = input<string>('');
  public readonly customLogo = input<string>();
  public readonly coverPageClasses = input<string>();

  protected readonly currentDate: Date = new Date();

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  public ngOnInit(): void {
    const isPdfService = this.activatedRoute.snapshot.queryParams?.pdfservice === 'true';
    if (!isPdfService || !this.portfolioId()) {
      // Make sure the portfolio report is only shown when used in the pdf service
      this.router.navigateByUrl(`/energy/${this.portfolioId() >= 0 ? this.portfolioId() : ''}`);
      return;
    }
  }
}
